import React, { Component } from 'react';
import CustomEditorItemComponent from '../components/custom/CustomEditorItemComponent';
import CustomTabv2, { CustomTabItem } from '../components/custom/CustomTabv2';
import SandboxApiContainer from '../components/sandbox/SandboxApiContainer';
import SandboxCsvContainer from '../components/sandbox/SandboxCsvContainer';
import SandboxJsonContainer from '../components/sandbox/SandboxJsonContainer';
import { TransactionJsonModel } from '../domain/stream/transaction/TransactionDomains';
import { query, repository, subscribe } from '@trlogic/client-js';
import { InstanceContainer } from '../config/binding/InstanceBinding';
import Injectables from '../constant/Injectables';
import CollectionNames from '../constant/CollectionNames';
import { addPagePath, changePagePath, clearPage } from '../redux/actions/PageActions';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../redux/store';
import Breadcrumb from '../components/Breadcrumb';
import ComponentName from '../constant/ComponentName';
import RoleHelper from '../RoleHelper';
import { ConfirmPopup } from 'primereact/confirmpopup';
import LanguageUtil from '../util/LanguageUtil';
import EnvironmentUtil from '../util/EnvironmentUtil';
import SandboxDatabaseContainer from 'components/sandbox/SandboxDatabaseContainer';
import SandboxHistoricalContainer from 'components/sandbox/SandboxHistoricalContainer';

class SandboxContainer extends Component<Props, State> {
  private eventSubscription: subscribe.Subscription | undefined;
  private computation: subscribe.Computation | undefined;
  private repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);
  private readonly environmentUtil: EnvironmentUtil = InstanceContainer.get(Injectables.ENVIRONMENT_UTIL);

  public state = new State();

  public render() {
    return (
      <div className={'flex flex-col w-full h-full'}>
        <Breadcrumb />
        <ConfirmPopup />
        <div className={'flex items-center w-full'}>
          <CustomEditorItemComponent
            name={'Sandbox'}
            description={LanguageUtil.get({ id: 'common.label.description', defaultMessage: 'Description' })}
            status={'ACTIVE'}
            icon={'sandbox'}
            component={ComponentName.SANDBOX}
            isUpdate={true}
            descriptionVisible={false}
            statusVisible={false}
            onChangeName={() => {}}
            onChangeDescription={() => {}}
          />
        </div>
        <div className={'flex items-center justify-start w-full h-full'}>
          <CustomTabv2 tab={this.getTabs()} />
        </div>
      </div>
    );
  }

  public async componentDidMount() {
    await this.startTracker();
  }

  public async componentWillUnmount() {
    this.props.clearPage();
    await this.stopTracker();
  }

  private startTracker = async () => {
    const eventQuery: query.SelectQueryBuilder = query.QueryBuilder.select().from(CollectionNames.TRANSACTIONS);
    this.eventSubscription = subscribe.Formica.subscribe(CollectionNames.TRANSACTIONS, eventQuery.build());
    this.computation = subscribe.Tracker.autorun(this.tracker, [this.eventSubscription]);
  };

  private tracker = async () => {
    if (this.eventSubscription?.ready()) {
      const eventQuery: query.Query = query.QueryBuilder.select().from(CollectionNames.TRANSACTIONS).build();
      const items: TransactionJsonModel[] = await this.repository.findMany(eventQuery);
      this.setState({ transactions: items });
    }
  };

  private stopTracker = async () => {
    await this.eventSubscription?.stop();
    this.computation?.stop();
  };

  private getTabs = (): CustomTabItem[] => {
    const { transactions } = this.state;
    return [
      {
        key: 'Api',
        label: LanguageUtil.get({ id: 'common.label.api', defaultMessage: 'API' }),
        content: <SandboxApiContainer transactions={transactions} />,
        visible: RoleHelper.canView('SandboxSimulator'),
      },
      {
        key: 'Csv',
        label: LanguageUtil.get({ id: 'common.label.csv', defaultMessage: 'CSV' }),
        content: <SandboxCsvContainer transactions={transactions} />,
        visible: RoleHelper.canView('SandboxCsv'),
      },
      {
        key: 'Json',
        label: LanguageUtil.get({ id: 'common.label.json', defaultMessage: 'JSON' }),
        content: <SandboxJsonContainer transactions={transactions} />,
        visible: RoleHelper.canView('SandboxJson'),
      },
      {
        key: 'Historical',
        label: LanguageUtil.get({ id: 'common.label.historical', defaultMessage: 'Historical' }),
        content: <SandboxHistoricalContainer transactions={transactions} />,
        visible: RoleHelper.canView('SandboxHistorical') && this.environmentUtil.getPages().historicalSandbox,
      },
      //TODO: will be revert
      // {
      //   key:"Database",
      //   label:LanguageUtil.get({id:"common.label.database",defaultMessage:"Database"}),
      //   content:<SandboxDatabaseContainer transactions={transactions}/>,
      //   visible:RoleHelper.canView("SandboxDatabase")
      // }
    ];
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  currentCategory: state.page.currentCategory,
  pagePath: state.page.pagePath,
});

const mapDispatchToProps = { addPagePath, changePagePath, clearPage };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

class State {
  transactions: TransactionJsonModel[] = [];
}

export default connector(SandboxContainer);
